import React from "react";
import Hero from "../components/sections/Hero";
import Marquee from "../components/sections/Marquee";
import Manifesto from "../components/sections/Manifesto";
import Services from "../components/sections/Services";
import RecipeGenerator from "../components/sections/RecipeGenerator";
import ShopPreview from "../components/sections/ShopPreview";
import MembershipCTA from "../components/sections/MembershipCTA";
import SocialSection from "../components/sections/SocialSection";

const Home = () => (
  <div data-testid="home-page">
    <Hero />
    <Marquee />
    <Manifesto />
    <Services />
    <RecipeGenerator />
    <MembershipCTA />
    <ShopPreview />
    <SocialSection />
  </div>
);

export default Home;
